export const defaultLoansState = function () {
    return {
        loans_loading: false,

        default_filter: {},
        default_funded_filter: {},
        default_pipeline_filter: {},

        funded_stats: {
            loan_count: 0,
            loan_amount_sum: 0,
            loan_amount_average: 0,
        },
        pipeline_stats: {
            loan_count: 0,
            loan_amount_sum: 0,
            loan_amount_average: 0,
        },
        bar_chart: [],
        loan_statuses: [],
        loan_programs: [],
        loan_types: [],
        loan_purposes: [],
        property_types: [],
        occupancies: [],
        selected: [],

        buyers_agents: [],
        sellers_agents: [],
        settlement_agents: [],
        attorneys: [],

        participant_roles: [],
        whitelisted_participant_roles: [],

        modalState: {
            email: false,
            emailLoanStatus: false,
        },

        loanParticipantsIsLoading: false,
        loan_participants: [],

        account_classifications: [],

        origination_fee_data_type: '',
        push_services: [],
    };
};

export const defaultLoansTableState = function () {
    return {
        search: null,
        sort: '-created_date',
        report_type: null,
        get_ids: null,

        created_date: '',
        pre_approval_issued_date: '',
        application_sent_date: '',
        application_received_date: '',
        lock_expire_date: '',
        funded_date: '',
        closing_date: '',
        loan_date: '',
        loan_arm_expiration_date: '',
        pre_approval_expiration_date: '',
        purchased_date: '',
        first_payment_date: '',
        documents_signed_date: '',
        credit_report_date: '',
        rate: {
            min: null,
            max: null,
        },
        amount: {
            min: null,
            max: null,
        },
        exclude_epo: null,
        loan_purpose_id: [],
        loan_type_id: [],
        loan_program_id: [],
        loan_status_id: [],
        city: null,
        state: [],
        zip: null,
        property_type: [],
        occupancy: [],
        referral_source: null,
        source: null,
        latest_loan: null,
        funded_anniversary: null,
        account_classification_system_name: [],
        origination_fee: {
            min: null,
            max: null,
        },
        lender_paid_compensation: {
            min: null,
            max: null,
        },
        channel: '',
        business_partner: '',
        partner_account: '',
        guarantee_type: '',
        borrower_entity_type: '',
        legal_entity_name: '',
        pricing_option: '',
        line_amount: {
            min: null,
            max: null,
        },
        available_line_amount: {
            min: null,
            max: null,
        },
        max_acquisition_ltc: {
            min: null,
            max: null,
        },
        max_rehab_ltc: {
            min: null,
            max: null,
        },
        max_ltv: {
            min: null,
            max: null,
        },
        margin: {
            min: null,
            max: null,
        },
        index: {
            min: null,
            max: null,
        },
        expected_interest_rate: {
            min: null,
            max: null,
        },
        principal_limit: {
            min: null,
            max: null,
        },
        available_principal_limit: {
            min: null,
            max: null,
        },
        upfront_mip: {
            min: null,
            max: null,
        },
        monthly_mi: {
            min: null,
            max: null,
        },
        third_party_costs: {
            min: null,
            max: null,
        },
        monthly_service_fee: {
            min: null,
            max: null,
        },
        term_payment_amount: {
            min: null,
            max: null,
        },
        tenure_payment: {
            min: null,
            max: null,
        },
        tenure_payment_amount: {
            min: null,
            max: null,
        },
        second_appraisal_value: {
            min: null,
            max: null,
        },
        second_appraisal_ordered_date: '',
        second_appraisal_scheduled_date: '',
        second_appraisal_received_date: '',
        origination_fee_data_type: '',
    };
};
